import { render, staticRenderFns } from "./discountAdmin.vue?vue&type=template&id=81b8aab2&scoped=true&"
import script from "./discountAdmin.vue?vue&type=script&lang=js&"
export * from "./discountAdmin.vue?vue&type=script&lang=js&"
import style0 from "./discountAdmin.vue?vue&type=style&index=0&id=81b8aab2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b8aab2",
  null
  
)

export default component.exports